/**
 * Core kernel exports.
 *
 * Singletons for the event bus and extension registry.
 */
export { EventBus } from "./event-bus.ts"
export type { EventMap } from "./events.ts"
export { ExtensionRegistry } from "./extension-registry.ts"

import { EventBus } from "./event-bus.ts"
import { ExtensionRegistry } from "./extension-registry.ts"

/** Global event bus singleton. */
export const eventBus = new EventBus()

/** Global extension registry singleton. */
export const extensionRegistry = new ExtensionRegistry()
